import { Helmet } from "react-helmet";
import { Text, Img } from "../../components";
import React, { useLayoutEffect } from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

const allPosts = {
  breakeven: {
    headingText:
      "Understanding and Achieving the Break-Even Point (BEP) in Restaurants",
    descriptionText: (
      <>
        The financial success of any restaurant lies in understanding and
        managing its key metrics. Among these, the break-even point (BEP) stands
        out as a critical measure. It's the point where your restaurant's total
        revenue equals its total costs, and every sale afterward contributes to
        profit.
        <br />
        <br />
        Achieving BEP requires careful planning:
        <br />
        <br />
        1- Cost Analysis: Keep track of fixed costs (rent, salaries) and
        variable costs (ingredients, utilities).
        <br />
        <br />
        2- Pricing Strategy: Set menu prices that reflect both value for
        customers and profitability for the business.
        <br />
        <br />
        3- Sales Targets: Focus on driving revenue through upselling,
        promotions, and consistent quality.
        <br />
        <br />
        4- Operational Efficiency: Minimize waste and optimize inventory to
        reduce costs.
        <br />
        <br />
      </>
    ),

    likeIconImage: "images/img_heart_rounded.svg",
    likeCountText: "30",
    commentCountText: "100",
    shareCountText: "50",
  },
  social: {
    headingText: "The Importance of Instagram for Restaurants",
    descriptionText: (
      <>
        Did you know 77% of diners check a restaurant’s Instagram before
        deciding to visit? 😲 Your profile is your first impression—make it
        irresistible!
        <br />
        <br />
        ✅ Showcase your best dishes with mouthwatering photos
        <br />
        ✅ Highlight customer experiences with UGC (user-generated content)
        <br />
        ✅ Keep your bio clear and engaging
        <br />
      </>
    ),
    likeIconImage: "images/img_heart_rounded.svg",
    likeCountText: "30",
    commentCountText: "100",
    shareCountText: "50",
  },
  marketing_roi: {
    headingText: "Tracking ROI on Restaurant Marketing Campaigns",
    descriptionText: (
      <>
        In a world of diverse marketing channels, it’s very important for
        restaurant owners to forecast and track the Return of Investment (ROI)
        on marketing spend, this will help you find your best channels, minimize
        over spending and measure your marketing effectiveness.
        <br />
        <br />
        <strong>Cost of Campaign</strong>
        <br />
        Add up all expenses, such as (Social media ads, Influencer fees,
        Discounts/offers given to customers, Design/production costs for flyers,
        posters, or videos)
        <br />
        <br />
        <strong>Total Revenue from Campaign</strong>
        <br />
        Track revenue directly attributable to the campaign using: (Sales during
        the campaign period (compare with a baseline or pre-campaign period),
        Coupon codes or promo codes specific to the campaign, Sales data from
        referred customers (e.g., from a QR code or affiliate link).
        <br />
        <br />
        <strong>Net Profit</strong>
        <br />
        Net Profit = Total Revenue from Campaign − Cost of Campaign
        <br />
        <br />
        <strong>Plug into the ROI Formula</strong>
        ROI = (Net Profit from Campaign / Cost of Campaign) x 100
      </>
    ),
    likeIconImage: "images/img_heart_rounded.svg",
    likeCountText: "30",
    commentCountText: "100",
    shareCountText: "50",
  },
  delivery_service: {
    headingText: "Key Factors to Consider when Launching Delivery Service",
    descriptionText: (
      <>
        <strong>1. Delivery Time Goal</strong>
        <br />
        - Decide on a maximum delivery time (e.g., 45 minutes from order
        placement).
        <br />
        - Account for food preparation time, typically 10–15 minutes for fast
        food.
        <br />
        <br />
        Example: If the delivery goal is 45 minutes and food prep takes 15
        minutes, the delivery driver has 30 minutes for travel.
        <br />
        <br />
        <strong>2. Average Travel Speed</strong>
        <br />
        - Estimate the average speed of delivery vehicles based on your area:
        <br />
        * Urban areas: ~20–30 km/h (due to traffic and stoplights).
        <br />
        * Suburban areas: ~30–50 km/h.
        <br />
        <br />
        Example: At 30 km/h, a delivery driver covers 15 km in 30 minutes.
        <br />
        <br />
        <strong>3. Service Quality</strong>
        <br />
        - Ensure the food arrives fresh and warm. Longer distances may affect
        quality.
        <br />
        - Consider factors like weather, traffic conditions, and road quality
        that might delay delivery.
        <br />
        - Ensure your packaging preserves the food quality and presentation.
        <br />
        <br />
        <strong>4. Driver Availability</strong>
        <br />
        - Ensure you have enough drivers to cover the proposed radius without
        compromising delivery time for other orders.
        <br />
        <br />
        <strong>5. Customer Density</strong>
        <br />- Focus on areas with high customer density to optimize delivery
        routes.
      </>
    ),
    likeIconImage: "images/img_heart_rounded.svg",
    likeCountText: "30",
    commentCountText: "100",
    shareCountText: "50",
  },
  tools: {
    headingText: "Tools to Help while offering Delivery Service",
    descriptionText: (
      <>
        <strong>1. Mapping Software:</strong>
        <br />
        Use Google Maps or similar tools to plot a delivery radius and check
        real-time traffic conditions.
        <br />
        <br />
        <strong>2. Delivery Platform Insights:</strong>
        <br />
        If using platforms like Talabat, elmenus or Zyda check their analytics
        for average delivery times and customer density.
        <br />
        <br />
        <strong>3. Customer Feedback:</strong>
        <br />
        Monitor complaints about delivery time or food quality to refine the
        radius.
      </>
    ),
    likeIconImage: "images/img_heart_rounded.svg",
    likeCountText: "30",
    commentCountText: "100",
    shareCountText: "50",
  },
};

export default function PostspagePage() {
  const location = useLocation();
  const { post } = location.state;
  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <Helmet>
        <title>Financial Tips for Restaurants - Verified by Suplyd</title>
        <meta
          name="description"
          content="Learn how to create a profitable P&L trend analysis for your restaurant. Discover key metrics for financial success and operational efficiency."
        />
      </Helmet>
      <div className="w-full">
        <div className="mb-[652px] flex flex-col gap-[34px]">
          <div className="ml-1 flex flex-col items-center gap-[22px] md:ml-0">
            <div className="self-stretch bg-white-a700">
              <div className="flex flex-col items-start">
                <div className="flex flex-col items-center rounded-[20px]">
                  <Link
                    to={".."}
                    className="flex h-[40px] w-[40px] items-center justify-center rounded-[20px] px-2"
                  >
                    <Img src="images/img_arrow_left.svg" />
                  </Link>
                </div>
              </div>
            </div>
            <div className="container-sm flex flex-col items-center px-14 lg:px-5 md:px-5">
              <div className="flex w-[20%] flex-col items-center gap-0.5 lg:w-full md:w-full">
                <div className="mb-2 flex items-center self-stretch sm:items-start sm:justify-center">
                  <Img
                    src="images/img_checkmark.svg"
                    alt="Checkmark"
                    className="h-[16px]"
                  />
                  <Text as="p" className="self-end text-[14px] font-normal">
                    <span className="text-gray-700">Verified by&nbsp;</span>
                    <span className="text-orange-900">Suplyd</span>
                  </Text>
                </div>
                <Text
                  size="text3xl"
                  as="p"
                  className="lg:text-[18px] lg:font-bold text-center leading-5 !text-black-900_01"
                >
                  {allPosts[post].headingText}
                </Text>
              </div>
            </div>
          </div>
          <div className="mx-1 flex flex-col items-center gap-1.5 md:mx-0">
            <Text
              as="p"
              className="text-[16px] font-normal leading-[19px] !text-black-900_01 sm:p-2.5"
            >
              {allPosts[post].descriptionText}
            </Text>
            <div className="flex items-center justify-center self-stretch sm:p-2.5">
              <div className="flex items-center px-0.5">
                <Img
                  src="images/img_favorite_red_a700.svg"
                  alt="Favorite"
                  className="h-[16px] self-end"
                />
                <Text
                  as="p"
                  className="!font-avenirarabic text-[12px] font-medium"
                >
                  {allPosts[post].likeCountText}
                </Text>
              </div>
              <div className="flex items-center px-0.5">
                <Img
                  src="images/img_search_blue_gray_200_1.svg"
                  alt="Search"
                  className="h-[16px] self-end"
                />
                <Text
                  as="p"
                  className="ml-2 !font-avenirarabic text-[12px] font-medium"
                >
                  {allPosts[post].shareCountText}
                </Text>
              </div>

              <div className="flex flex-1 items-center px-2">
                <Img
                  src="images/img_comment_icon.svg"
                  alt="Commenticon"
                  className="h-[16px] self-end"
                />
                <Text
                  as="p"
                  className="!font-avenirarabic text-[12px] font-medium"
                >
                  {allPosts[post].commentCountText}
                </Text>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
